import { render, staticRenderFns } from "./TableFolders.vue?vue&type=template&id=18eb5291&scoped=true&"
import script from "./TableFolders.vue?vue&type=script&lang=js&"
export * from "./TableFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb5291",
  null
  
)

export default component.exports